export const CP_ID = '507f1f78bcf86cd799439036';
export const NCP_ID = '507f1f78bcf86cd799439037';

export const PMP_TELEPHONE_INTERVIEW_STATUS_ATTEMPTED_ID = '507f2f78bcf86cd799439036';
export const PMP_TELEPHONE_INTERVIEW_STATUS_DECLINED_ID = '507f3f78bcf86cd799439037';
export const PMP_TELEPHONE_INTERVIEW_STATUS_COMPLETED_ID = '507f4f78bcf86cd799439037';
export const PMP_TELEPHONE_INTERVIEW_STATUS_NA_ID = '507f5f78bcf86cd799439037';
